// extracted by mini-css-extract-plugin
export var blueText = "index-module--blueText--565cd";
export var mainImage = "index-module--mainImage--c3047";